/**
 * Reads `status` from either the error itself or a nested `response` object
 * without forcing a particular HTTP-client shape. Returns `undefined` when the
 * error doesn't expose a numeric status code.
 *
 * Shared by `ArtifactPreviewError` (404 copy + Close-only flow) and the
 * preview modal's universal close handler (invalidate the Library list when
 * the detail query 404'd so the stale card drops on next paint regardless
 * of which dismiss path the user used).
 */
export function extractStatus(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null) return undefined;

  const direct = (error as { status?: unknown }).status;
  if (typeof direct === 'number') return direct;

  const response = (error as { response?: unknown }).response;
  if (typeof response === 'object' && response !== null) {
    const nested = (response as { status?: unknown }).status;
    if (typeof nested === 'number') return nested;
  }

  return undefined;
}
